module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "order-modal"
    }
  }, [_c('div', {
    staticClass: "tingle-modal order-modal-mask"
  }, [_c('div', {
    staticClass: "tingle-modal-box order-modal-wrapper",
    class: [{
      'order-modal-wrapper--infobox': _vm.infobox
    }, {
      'order-modal-wrapper--private': _vm.mode
    }, {
      'order-modal-wrapper--form': _vm.form
    }]
  }, [_c('div', {
    staticClass: "tingle-modal-box__content order-modal-container"
  }, [_vm._t("content"), _vm._v(" "), _c('button', {
    staticClass: "tingle-modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "lang": "en"
    }
  }, [_vm._v("Close")])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a717cf6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Modal.vue
// module id = 877
// module chunks = 0